module.exports = __webpack_public_path__ + "static/media/item1.ca2c49d1.jpg";